import {Box, Button, Divider, Stack, Typography} from "@mui/material";
import GenerationYield from "../GenerationYieldChart/GenerationYield";
import GenerationYieldComparison from "../GenerationYieldComparisonChart/GenerationYieldComparison";
import React, {useEffect, useState} from "react";
import {
    ACard,
    Period,
    PeriodSelector,
    PeriodSelectorGroupBy,
    AToggleButtonGroup
} from "@atiautomacao/ati-ui-library";
import IconButton from "@mui/material/IconButton";

import {useAppSelector} from "../../../Config/Hooks";
import {hasPermission} from "../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../Config/Constants";
import { ColorInformationGenerationYieldChart, NewHtmlTooltip } from "../../../Utils/ColorInformation";
import { ChangeCircleOutlined, SimCardDownloadOutlined } from "@mui/icons-material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
export default function YeldChartComparison() {
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSearchByPdf = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_PDF_EXPORT, AUTHORITIES.SEARCH_REPORT, AUTHORITIES.EXPORT_YIELD, AUTHORITIES.PDF_EXPORT_YIELD
    ]);
    const isAuthorizedToSearchByCsv = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_CSV_EXPORT, AUTHORITIES.EXPORT_YIELD, AUTHORITIES.CSV_EXPORT_YIELD
    ]);
    const isAuthorizedToSearchByExcel = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_EXCEL_EXPORT, AUTHORITIES.EXPORT_YIELD, AUTHORITIES.EXCEL_EXPORT_YIELD
    ]);
    let [yieldValue, setYieldValue] = useState<string>("1");
    const initialYieldPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };
    const initialYieldComparisonPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };

    const yieldGroupsInterval = {
        week: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6},
        month: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 30},
        year: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 11},
        general: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6}
    };
    const yieldGroups : PeriodSelectorGroupBy[] = ["week", "month", "year", "general"];

    const [period, setPeriod] = useState<Period>(yieldValue === "0" ? initialYieldPeriod : initialYieldComparisonPeriod);

    const handleTabChange = (period: Period) => {
        setPeriod(period);
    }
    useEffect(() => {
    }, [period]);

    const handleChangeYield = (event: React.MouseEvent<HTMLElement>, value: string | null) => {
        setYieldValue(value ?? "0");
    };

    return (
        <ACard
            key={`chart-skid-active-power`}
            title="Produtividade"
            ariaLabel={"dashboard-overview-yield-comparison"}
            headerControlsPosition={"header"}
            styleProps={{
                cardStyle: { height: 463},
                contentStyle: { padding: '0 16px', height: 408, alignItems: 'center'},
                titleStyle: { alignItems: 'center', display: 'flex' },
                subTitleStyle: { display: 'none' },
                headerStyle: { flexDirection: 'row' },
                headerActionsStyle: { alignItems: 'center', display: 'flex'},
            }}
            headerControls={
            <Stack direction="row" spacing={2}>
                <PeriodSelector
                    styleProps={{base: {flexDirection: "row", display: "flex", alignItems: "center", padding: '8px 0'}}}
                    mode="hybrid"
                    hideDatetime={false}
                    disableHourSelector={true}
                    inputFormat={'dd/MM/yyyy'}
                    hideGroup={false}
                    periodInterval={yieldGroupsInterval}
                    period={period}
                    onChange={handleTabChange}
                    groupByOptions={yieldGroups}
                />
            </Stack>
            }
            InformationTooltip={
                yieldValue === "0" ?
                <NewHtmlTooltip
                    title={<ColorInformationGenerationYieldChart />}
                >
                    <Button>HTML</Button>
                </NewHtmlTooltip>
                : null
            }
            headerActions={
                <Stack direction="column" spacing={"8px"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 12px' }}>
                        <IconButton disabled={true} size="small" >
                            <SimCardDownloadOutlined sx={{ marginRight: '12px' }} />
                            <Typography variant="body2">Baixar como CSV</Typography>
                        </IconButton>
                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 12px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '32px' }}>
                            <IconButton sx={{ borderRadius: '4px' }} size="small" onClick={() => setYieldValue("1")}>
                                <ChangeCircleOutlined sx={{ marginRight: '12px' }} />
                                <Typography variant="body2">Alterar visão</Typography>

                            </IconButton>

                        </Box>
                        <AToggleButtonGroup
                            styleProps={{
                                toggleButtonGroup: {
                                    paddingLeft: '4px',
                                    height: '30px',
                                },
                                toggleButton: {
                                    height: '30px',
                                },
                                typography: {
                                    fontSize: '14px',
                                },
                            }}
                            options={[
                                { value: "0", label: 'Comparativo' },
                                { value: "1", label: 'Absoluto' },
                            ]}
                            value={yieldValue}
                            exclusive
                            onChange={handleChangeYield}

                        />
                    </Box>
                    <Divider />
                </Stack>
            }
        >
            { yieldValue === "0" ?
                <GenerationYield period={period}/>
                :
                <GenerationYieldComparison period={period}/>
            }
        </ACard>
    )
}